import { render, staticRenderFns } from "./productUkComplianceOfficerList.vue?vue&type=template&id=8a6b5276&scoped=true&"
import script from "./productUkComplianceOfficerList.vue?vue&type=script&lang=ts&"
export * from "./productUkComplianceOfficerList.vue?vue&type=script&lang=ts&"
import style0 from "./productUkComplianceOfficerList.vue?vue&type=style&index=0&id=8a6b5276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6b5276",
  null
  
)

export default component.exports